// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_homeimageIcon__dABQ5 {
    display: bloc;
    width: 35%;
    max-width: 32rem;
    min-width: 18rem;
    height: auto;
    margin-right: 4rem;
}

.Home_mainHomeContainer__gLLve {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4vw;
    height: 60vh;
    min-height: calc(100vh - 10rem);
    padding: 3rem 5%;
    box-sizing: border-box;
}

.Home_homeTitle__duF7K h1,
.Home_homeTitle__duF7K span,
.Home_homeTitle__duF7K div {
    color: #2C5C72 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;;IAGI,yBAAyB;AAC7B","sourcesContent":[".homeimageIcon {\r\n    display: bloc;\r\n    width: 35%;\r\n    max-width: 32rem;\r\n    min-width: 18rem;\r\n    height: auto;\r\n    margin-right: 4rem;\r\n}\r\n\r\n.mainHomeContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 4vw;\r\n    height: 60vh;\r\n    min-height: calc(100vh - 10rem);\r\n    padding: 3rem 5%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.homeTitle :global(h1),\r\n.homeTitle :global(span),\r\n.homeTitle :global(div) {\r\n    color: #2C5C72 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeimageIcon": `Home_homeimageIcon__dABQ5`,
	"mainHomeContainer": `Home_mainHomeContainer__gLLve`,
	"homeTitle": `Home_homeTitle__duF7K`
};
export default ___CSS_LOADER_EXPORT___;
